module.exports = __webpack_public_path__ + "static/media/User Quide.7bb6bce1.pdf";